import { defineRecipe } from '@chakra-ui/react'
import { BgColors, TextColors } from 'commons/design-system/tokens'

export const button = defineRecipe({
	base: {
		bg: 'bg.muted',
		color: 'fg',
		borderRadius: 'l2'
	},
	variants: {
		variant: {
			danger: {
				bg: BgColors.STATUS_ERROR,
				color: TextColors.STATUS_ERROR
			},
			link: {
				bg: 'transparent',
				padding: 0,
				height: 'auto',
				color: TextColors.HIGHLIGHT_ACTION,
				_hover: {
					textDecoration: 'underline',
					bg: 'transparent'
				},
				_active: {
					bg: 'transparent'
				}
			}
		}
	}
})
